"use client"

// type AppProps = {
//   handleSubmit: (e: React.FormEvent<HTMLFormElement>) => void
//   email: string
//   setEmail: (email: string) => void
// }
import type { FormEvent } from "react"

import React, { useState } from "react"
import toast from "react-hot-toast"

import { contactService } from "#modules/contact/contact.service"

const ContactFormServerTransparent = ({ buttonCaption, artistFlag }: { buttonCaption: string; artistFlag: boolean }) => {
  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    toast.loading("Einen Moment bitte...")

    try {
      await contactService.sendContactForm({ email, artist: artistFlag })

      toast.dismiss()
      toast.success("Vielen Dank. Sie haben eine Bestätigung per E-Mail erhalten.")
      setEmail("")
    } catch (e) {
      toast.dismiss()
      toast.error("Ein Fehler ist aufgetreten. Bitte überprüfen Sie die Eingabe und versuchen es erneut.")
    }
  }

  const [email, setEmail] = useState("")

  return (
    <>
      <div className={"relative flex h-44 flex-col items-center justify-start"}>
        <div className={"absolute -ml-56 mt-24 text-nm font-bold text-black opacity-10"}>Einfach.</div>
        <div className={"absolute ml-56 mt-20 text-nm font-bold text-black opacity-10"}>Kostenlos.</div>
        <div className={"absolute ml-5 mt-32 text-nm font-bold text-black opacity-10"}>Unverbindlich.</div>
        <form onSubmit={e => handleSubmit(e)} className={"relative mt-5 flex max-w-[300px] flex-col items-center justify-center font-inter"}>
          <div className={"rounded border-none shadow-[0px_4px_25px_rgba(0,0,0,0.14)]"}>
            <input
              value={email}
              placeholder={"E-Mail-Adresse"}
              onChange={e => setEmail(e.target.value)}
              className={"bg-primary-peach-100 h-12 w-[300px] max-w-[300px] p-6 text-xs text-black"}
            />
          </div>
          <input
            type="submit"
            value={buttonCaption}
            className={"mt-4 h-9 w-32 cursor-pointer border-none bg-gold-100 font-inter text-bt font-bold text-black hover:bg-purple-60 hover:text-gold-100"}
          />
        </form>
      </div>
    </>
  )
}

export default ContactFormServerTransparent
